import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await login(form.email, form.password); toast.success("Welcome back"); navigate("/account"); }
    catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };
  return (
    <main className="max-w-md mx-auto px-6 py-24" data-testid="login-page">
      <p className="eyebrow text-neutral-600">Account</p>
      <h1 className="font-serif text-4xl mt-2 mb-10">Sign in</h1>
      <form onSubmit={submit} className="space-y-4">
        <input type="email" required placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
          data-testid="login-email" className="w-full bg-cream border border-hair px-4 py-3.5 text-sm outline-none focus:border-[var(--gold)]" />
        <input type="password" required placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
          data-testid="login-password" className="w-full bg-cream border border-hair px-4 py-3.5 text-sm outline-none focus:border-[var(--gold)]" />
        <button disabled={loading} className="btn-primary w-full" data-testid="login-submit">{loading ? "Signing in…" : "Sign in"}</button>
      </form>
      <p className="text-sm text-neutral-500 mt-6">No account? <Link to="/register" className="underline text-neutral-900">Register</Link></p>
    </main>
  );
}
